import React, { forwardRef, type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./text-spacing.module.scss";

export const Element = {
  DIV: "div",
  SPAN: "span",
} as const;

export type TextSpacingElementType = (typeof Element)[keyof typeof Element];

export type TextSpacingProps = Omit<BaseProps, "children"> & {
  children: ReactNode;
  element?: TextSpacingElementType;
};

const cx = c.bind(styles);
const rootClassName = "purpur-text-spacing";

export const TextSpacing = forwardRef<HTMLElement, TextSpacingProps>(
  ({ children, className, element: ElementTag = "div" as React.ElementType, ...props }, ref) => {
    return (
      <ElementTag ref={ref} className={cx(className, rootClassName)} {...props}>
        {children}
      </ElementTag>
    );
  }
);

TextSpacing.displayName = "TextSpacing";
